import React from 'react';
import { Layout } from '../components/Layout';
import { DynamicContentRenderer } from '../components/DynamicContentRenderer';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Alert, AlertDescription } from '../components/ui/alert';
import { Info } from 'lucide-react';

export const TestDynamicContent = () => {
  return (
    <Layout>
      <div className="space-y-6">
        {/* Static Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold">Dynamic Content Test Page</h1>
            <p className="text-muted-foreground">
              This page demonstrates the Content Manager functionality
            </p>
          </div>
        </div>

        {/* Info Alert */}
        <Alert>
          <Info className="h-4 w-4" />
          <AlertDescription>
            The sections below are dynamically loaded from the Content Manager. 
            Go to <strong>Platform Editor → Content Manager</strong> to manage these sections.
          </AlertDescription>
        </Alert>

        {/* Dynamic Content - will render sections from the API */}
        <DynamicContentRenderer pageKey="admin-dashboard">
          {/* Fallback content if no sections exist */}
          <Card>
            <CardHeader>
              <CardTitle>No Dynamic Content Yet</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                Create content sections using the Content Manager to see them here.
              </p>
            </CardContent>
          </Card>
        </DynamicContentRenderer>
      </div>
    </Layout>
  );
};
